import {Injectable} from '@angular/core';
import {QualityBasedRoutingApiService} from '../../../../services/api/settings/routing/quality-based-routing/quality-based-routing-api.service';
import {OfflineRoutingInterfaceApiService} from '../../../../services/api/network/offline/routing-interface/offline-routing-interface-api.service';
import {OfflineNodeApiService} from '../../../../services/api/network/offline/node/offline-node-api.service';
import {OfflineConnectionApiService} from '../../../../services/api/network/offline/connection/offline-connection-api.service';
import {OfflineVoipPeerApiService} from '../../../../services/api/network/offline/voip-peer/offline-voip-peer-api.service';
import {OfflinePeerConnectionApiService} from '../../../../services/api/network/offline/peer-connection/offline-peer-connection-api.service';
import {MatDialog} from '@angular/material/dialog';
import {OfflineConnectionsDialogComponent} from '../../../offline-map/dialogs/offline-connections-dialog/offline-connections-dialog.component';
import {ConfirmationDialogComponent} from '../../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {SnackBarService} from '../../../../services/common/snack-bar/snack-bar.service';
import {OfflineMapService} from '../../map/offline-map/offline-map.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineConnectionService {

  constructor(public dialog: MatDialog,
              private offlinePconApiService: OfflinePeerConnectionApiService,
              private offlineVoipPeerApiService: OfflineVoipPeerApiService,
              private offlineConnectionApiService: OfflineConnectionApiService,
              private offlineNodeApiService: OfflineNodeApiService,
              private snackBarService: SnackBarService,
              private offlineMapService: OfflineMapService,
              private offlineRoutingInterfaceApiService: OfflineRoutingInterfaceApiService,
              private qualityBasedRoutingApiService: QualityBasedRoutingApiService) {
  }

  public editConnection(id: number): any {
    Promise.all([this.qualityBasedRoutingApiService.getQualityBasedRoutingSettings()
      .toPromise(), this.offlineConnectionApiService.getConnectionForMap(id)]).then(value => {
      const connection = value[1];

      Promise.all([this.offlineNodeApiService.getNodeForMap(connection.connections[0].srcNodeId),
        this.offlineNodeApiService.getNodeForMap(connection.connections[0].destNodeId),
        this.offlineRoutingInterfaceApiService.getRoutingInterfaceForMap(connection.connections[0].srcRoutingInterface),
        this.offlineRoutingInterfaceApiService.getRoutingInterfaceForMap(connection.connections[0].destRoutingInterface)
      ]).then(data => {
        const dialogRef = this.dialog.open(OfflineConnectionsDialogComponent, {
          width: '700px',
          data: {
            isEditMode: true,
            selectedItem: connection,
            srcNode: data[0],
            destNode: data[1],
            srcRI: data[2],
            destRI: data[3]
          }
        });

        dialogRef.componentInstance.onApply.subscribe(connectionResult => {
          this.offlineConnectionApiService.editConnection(connectionResult, id).then(() => {
            dialogRef.close();
            this.refreshDiagram();
          }).catch(() => {});
        });
      });
    });
  }

  public addConnection(fromNodeId ?: number, toNodeId ?: number): any {
    const connection = {
      srcNode: fromNodeId,
      destNode: toNodeId
    };

    Promise.all([this.offlineNodeApiService.getNodesForMap(),
      this.qualityBasedRoutingApiService.getQualityBasedRoutingSettings(),
      this.offlineRoutingInterfaceApiService.getRoutingInterfacesForMap()])
      .then(data => {
        const dialogData = {
          isEditMode: false,
          nodes: data[0],
          advancedConditions: data[1],
          routingInterface: data[2],
          selectedItem: connection
        };

        const dialogRef = this.dialog.open(OfflineConnectionsDialogComponent, {
          width: '700px',
          data: dialogData
        });

        dialogRef.componentInstance.onApply.subscribe(connectionResult => {
          this.offlineConnectionApiService.addConnection(dialogData.selectedItem).then(() => {
            dialogRef.close();
            this.refreshDiagram();
          }).catch(() => {
            this.refreshDiagram();
          });
        });

        dialogRef.componentInstance.onCancel.subscribe(() => this.refreshDiagram());
      });
  }

  public deleteConnection(connection): void {
    const confirmationMessage = `Are you sure you want to delete this connection: "${connection.name}" ?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.offlineConnectionApiService.deleteConnection(connection.id).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${connection.name}" successfully deleted`);
        this.refreshDiagram();
      });
    });
  }

  private editOfflineConnectionInServer(connection, id: number): void {
    this.offlineConnectionApiService.editConnection(connection, id)
      .then(() => {
        this.refreshDiagram();
        // this.sharedEventService.broadcast('closeOfflineConnectionDialog');
      }).catch(() => {});
  }

  private addOfflineConnectionInServer(connection): void {
    this.offlineConnectionApiService.addConnection(connection)
      .then(() => {
        // this.sharedEventService.broadcast('ConnectionTableRefresh');
        // this.sharedEventService.broadcast('closeOfflineConnectionDialog');
        this.refreshDiagram();
      }).catch(() => {
        this.refreshDiagram();
      }
    );
  }

  private refreshDiagram(): void {
    this.offlineMapService.refresh();
  }
}
